/** Public dealership page URL (`/dealership/{userId}`). */
export function dealershipPublicHref(userId: number): string {
  return `/dealership/${userId}`;
}

/** True when listing card data points to a public dealership page. */
export function isPublicDealershipSeller(car: {
  sellerId?: number;
  sellerType?: string | null;
}): car is { sellerId: number; sellerType?: string | null } {
  return car.sellerType === "dealership" && typeof car.sellerId === "number" && car.sellerId > 0;
}
